import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "caretdown",
  "use": "caretdown-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"caretdown\"><title>caretdown</title><path d=\"M1.188 6.125l6.297 7.641q.203.234.5.234t.5-.234l6.328-7.641q.281-.313.109-.703t-.609-.391H1.688q-.438 0-.609.391t.109.703z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/caretdown.svg
// module id = 514
// module chunks = 0